import iconSpriteInfo from '@gitlab/svgs/dist/icons.json';
import { GlIcon, GlLink } from '@gitlab/ui';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { titleInLinkSafeHtmlConfig } from '~/lib/dompurify';
import { ISSUABLE_EPIC } from '../../constants';
export default {
    name: 'DisclosureHierarchyItem',
    components: {
        GlIcon,
        GlLink
    },
    directives: {
        SafeHtml
    },
    titleInLinkSafeHtmlConfig,
    props: {
        /**
     * Path item in the form:
     * ```
     * {
     *   titleHtml: String (rendered as HTML)
     *   message:   String (rendered as plain text)
     *   icon:      String, optional
     *   ancestorNotAvailable: Boolean, optional
     * }
     * ```
     * Exactly one of either titleHtml or message must be provided.
     */ item: {
            type: Object,
            required: false,
            default: ()=>{}
        },
        itemId: {
            type: String,
            required: false,
            default: null
        }
    },
    methods: {
        shouldDisplayIcon (icon) {
            if (icon === ISSUABLE_EPIC) return true;
            return icon && iconSpriteInfo.icons.includes(icon);
        }
    }
};
